import React from "react";

// Tabs components
import SimulationsDashboard from "./dashboard-tabs/simulations/simulations-dashboard";
import HiringsDashboard from "./dashboard-tabs/hirings/hirings-dashboard";
import InsurancePremiumPortfolioDashboard from "./dashboard-tabs/insurance-premium-portfolio/insurance-premium-portfolio-dashboard";
import RenewalPolicies from "./dashboard-tabs/renewal-policies/renewal-policies-dashboard";
import EIACFiles from "./dashboard-tabs/eiac-files/eiac-files-dashboard";
import UnpaidDashboard from "./dashboard-tabs/unpaid/unpaid-dashboard";

import { TABPARAMNAME } from "../../../constants/clientsDashboard";
import { getPrivilege } from "../../../utils/privileges";
import { PrivilegeCode } from "../../../services/PrivilegesServices-dto";
import { TabsConfig, PartialTabsConfig, TabParamName, TabConfig } from "./clients-dashboard-types";
import { UseGenerateDataError } from "./hooks/useGenerateData.types";

export const TABS_CONFIG: TabsConfig = {
  [TABPARAMNAME.SIMULACIONES]: {
    tabName: "simulaciones",
    privilegeName: PrivilegeCode.CM_SIMULACIONES,
    component: (props) => <SimulationsDashboard {...props} />,
  },
  [TABPARAMNAME.SOLICITUDES]: {
    tabName: "solicitudes",
    privilegeName: PrivilegeCode.CM_SOLICITUDES,
    component: (props) => <HiringsDashboard {...props} />,
  },
  [TABPARAMNAME.CARTERAS]: {
    tabName: "carteras (primas)",
    privilegeName: PrivilegeCode.CM_CARTERAS,
    component: (props) => <InsurancePremiumPortfolioDashboard {...props} />,
  },
  [TABPARAMNAME.RENOVACIONES]: {
    tabName: "pólizas en renovación",
    privilegeName: PrivilegeCode.CM_RENOVACIONES,
    component: (props) => <RenewalPolicies {...props} />,
  },
  [TABPARAMNAME.IMPAGADOS]: {
    tabName: "impagados",
    privilegeName: PrivilegeCode.CM_IMPAGADOS,
    component: (props) => <UnpaidDashboard {...props} />,
  },
  [TABPARAMNAME.FICHEROS_EIAC]: {
    tabName: "Ficheros EIAC",
    privilegeName: PrivilegeCode.CM_EIAC,
    component: (props) => <EIACFiles {...props} />,
  },
};

export const getUserPrivilegesTabs = (user: {
  excludedPrivileges?: PrivilegeCode[];
}): PartialTabsConfig => {
  const userTabs: PartialTabsConfig = {};
  for (let key in TABS_CONFIG) {
    const tabKey = key as TabParamName;
    const privilege = getPrivilege(user, TABS_CONFIG[tabKey].privilegeName);
    if (privilege) {
      userTabs[tabKey] = TABS_CONFIG[tabKey];
    }
  }

  return userTabs;
};

// Función de tipo guarda de TS para evitar aserciones de tipo
export function isTabConfig(tab: TabConfig | undefined): tab is TabConfig {
  return tab !== undefined;
}

export function formatErrorList(error: UseGenerateDataError): string[] {
  return [
    ...(error.simulations
      ? [`Se ha producido un error en la recuperación de las simulaciones: ${error.simulations}`]
      : []),
    ...(error.hirings
      ? [`Se ha producido un error en la recuperación de las contrataciones: ${error.hirings}`]
      : []),
    ...(error.insurancePremiumPortfolio
      ? [
          `Se ha producido un error en la recuperación de los datos de las carteras (primas): ${error.insurancePremiumPortfolio}`,
        ]
      : []),
  ];
}

export const formatNumber = (number: string | number): string => {
  const newNumber = typeof number === "string" ? parseFloat(number) : number;
  return new Intl.NumberFormat("es-ES", { minimumIntegerDigits: 1, useGrouping: true }).format(
    newNumber
  );
};
